// extracted by mini-css-extract-plugin
module.exports = {"returnReview":"review_returnReview__Rcm41"};